<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Document No.
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryDocNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            v-on:keydown.enter.prevent="doDocNoFilters"
                            data-vv-scope="queryDocNoFilterForm"
                            v-model="filtersDocNo.documentNo"
                            :label="filtersDocNoLabel.documentNo"
                            :error-messages="errors.collect('filterDocNo')"
                            data-vv-name="filterDocNo"
                            :data-vv-as="filtersDocNoLabel.documentNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearDocNoFilters(true)">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doDocNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="callerPage === 'MatchLater'">
        <v-data-table
          :headers="bmDocNoHeaders"
          :items="docNoItems"
          v-bind:options.sync="paginationDocNo"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsDocNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.branch }}</td>
              <td>{{ row.item.tranType }}</td>
              <td>{{ row.item.docNo }}</td>
              <td>{{ row.item.fund }}</td>
              <td>{{ row.item.acctNoSfx }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignDocNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="mt-2" v-else>
        <v-data-table
          :headers="docNoHeaders"
          :items="docNoItems"
          v-bind:options.sync="paginationDocNo"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsDocNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.docNo }}</td>
              <td>{{ row.item.acctNo }}</td>
              <td>{{ row.item.branch }}</td>
              <td>{{ row.item.tranType }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignDocNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationDocNo: {
        page: 1
      }
    }
  },
  mounted() {
  },
  watch: {
    boolRefresh: function(value) {
      if (value) {
        this.doClearDocNoFilters()
      }
    },
    'paginationDocNo': function(value) {
      this.doClearDocNoFilters()
    }
  },
  methods: {
    closeDialog() {
      this.filtersDocNo.documentNo = ''
      this.$emit('close')
    },
    doClearDocNoFilters(toClear) {
      if (toClear === true) {
        this.filtersDocNo.documentNo = null
      }
      this.resetPaginationDocNoSuppl()
      if (this.callerPage === 'Receipts') {
        this.fetchDocNoHelpList(this.callerPage)
      } else if (this.callerPage === 'VoidAccountTransaction') {
        this.filtersDocNo.tranType = this.tranType
        this.filtersDocNo.branch = this.branch
        this.filtersDocNo.accountNo = this.accountNo
        this.paginationDocNoSuppl.callerPage = this.callerPage
        this.fetchDocNoData('', '', this.callerPage)
        // AR: Added 30-May-2020
      } else if (this.callerPage === 'AccountsDocument') {
        this.filtersDocNo.tranType = this.tranType
        this.filtersDocNo.branch = this.branch
        this.filtersDocNo.docPrtd = this.docPrtd
        this.filtersDocNo.docPrtILN = this.docPrtILN
        this.paginationDocNoSuppl.callerPage = this.callerPage
        this.paginationDocNoSuppl.transaction = this.callerPage
        this.fetchDocNoData(this.callerPage, '', this.callerPage)
      } else if (this.callerPage === 'MatchLater') {
        this.paginationDocNoSuppl.callerPage = this.callerPage
        this.filtersDocNo.multiFundSfxCurr = this.multiFundSfxCurr
        this.filtersDocNo.accountNo = this.accountNo
        this.filtersDocNo.fund = this.fund
        this.filtersDocNo.acctNoSfx = this.acctNoSfx
        this.filtersDocNo.curr = this.curr
        this.fetchDocNoHelpList(this.callerPage)
      } else if (this.callerPage === 'UnsetClaimsDocPrintFlag') {
        this.filtersDocNo.tranType = this.tranType
        this.filtersDocNo.branch = this.branch
        this.filtersDocNo.fund = this.fund
        this.filtersDocNo.docPrtd = true
        this.filtersDocNo.tranRel = false
        this.paginationDocNoSuppl.callerPage = this.callerPage
        this.paginationDocNoSuppl.transaction = this.callerPage
        this.fetchDocNoData(this.callerPage, '', this.callerPage)
      } else {
        this.filtersDocNo.extraModuleRequest = this.extraModuleRequest
        this.filtersDocNo.tranType = this.tranType
        this.filtersDocNo.policyNo = this.policyNo
        this.filtersDocNo.accountNo = this.accountNo
        this.filtersDocNo.branch = this.branch
        this.filtersDocNo.fund = this.fund
        this.filtersDocNo.acctNoSfx = this.acctNoSfx
        this.fetchDocNoData(this.transaction, this.action)
      }
    },
    doDocNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryDocNoFilterForm').then(result => {
        this.resetPaginationDocNoSuppl()
        if (result) {
          this.paginationDocNo.page = 1
          this.filtersDocNo.fromExclGsttran = this.fromExclGsttran
          if (this.callerPage === 'Receipts') {
            this.fetchDocNoHelpList(this.callerPage)
          } else if (this.callerPage === 'VoidAccountTransaction') {
            this.filtersDocNo.tranType = this.tranType
            this.filtersDocNo.branch = this.branch
            this.filtersDocNo.accountNo = this.accountNo
            this.paginationDocNoSuppl.callerPage = this.callerPage
            this.fetchDocNoHelpList(this.callerPage)
            // AR: Added 30-May-2020
          } else if (this.callerPage === 'AccountsDocument') {
            this.filtersDocNo.tranType = this.tranType
            this.filtersDocNo.branch = this.branch
            this.filtersDocNo.docPrtd = this.docPrtd
            this.filtersDocNo.docPrtILN = this.docPrtILN
            this.paginationDocNoSuppl.callerPage = this.callerPage
            this.paginationDocNoSuppl.transaction = this.callerPage
            this.fetchDocNoData(this.callerPage, '', this.callerPage)
          } else if (this.callerPage === 'MatchLater') {
            this.paginationDocNoSuppl.callerPage = this.callerPage
            this.filtersDocNo.multiFundSfxCurr = this.multiFundSfxCurr
            this.filtersDocNo.accountNo = this.accountNo
            this.filtersDocNo.fund = this.fund
            this.filtersDocNo.acctNoSfx = this.acctNoSfx
            this.filtersDocNo.curr = this.curr
            this.fetchDocNoHelpList(this.callerPage)
          } else if (this.callerPage === 'UnsetClaimsDocPrintFlag') {
            this.paginationDocNoSuppl.callerPage = this.callerPage
            this.filtersDocNo.branch = this.branch
            this.filtersDocNo.fund = this.fund
            this.filtersDocNo.tranType = this.tranType
            this.fetchDocNoHelpList(this.callerPage)
          } else {
            this.filtersDocNo.tranType = this.tranType
            this.filtersDocNo.policyNo = this.policyNo
            this.filtersDocNo.accountNo = this.accountNo
            this.paginationDocNoSuppl.callerPage = this.callerPage
            this.paginationDocNoSuppl.transaction = this.transaction
            this.paginationDocNoSuppl.action = this.action
            this.filtersDocNo.branch = this.branch
            this.filtersDocNo.fund = this.fund
            this.filtersDocNo.acctNoSfx = this.acctNoSfx
            this.fetchDocNoData(this.transaction, this.action)
          }
        }
      })
    },
    resetPaginationDocNoSuppl() {
      this.paginationDocNoSuppl.callerPage = undefined
      this.paginationDocNoSuppl.transaction = undefined
      this.paginationDocNoSuppl.action = undefined
    },
    assignDocNo(data) {
      // Use $emit to call parent Accounts page method assignDocNo and pass the value
      this.$emit('assign-doc-no', data.docNo)
      this.$emit('assign-doc-no-info', data)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    transaction: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    callerPage: {
      type: String,
      default: ''
    },
    extraModuleRequest: {
      type: String,
      default: ''
    },
    tranType: {
      type: String,
      default: ''
    },
    policyNo: {
      type: String,
      default: ''
    },
    accountNo: {
      type: String,
      default: ''
    },
    branch: {
      type: String,
      default: ''
    },
    docPrtd: {
      type: Boolean
    },
    docPrtILN: {
      type: String,
      default: ''
    },
    multiFundSfxCurr: {
      type: Boolean,
      default: false
    },
    fund: {
      type: String,
      default: ''
    },
    acctNoSfx: {
      type: String,
      default: ''
    },
    curr: {
      type: String,
      default: ''
    },
    fromExclGsttran: {
      type: Boolean,
      default: false
    }
  },
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin]
}
</script>
